<template>
    <div>
        <v-navigation-drawer
                v-model="drawer"
                app
        >
            <v-list>
                <template v-for="(item, i) in menus">
                    <v-list-item
                            :key="i"
                            link
                            v-if="item.navgroup === undefined"
                            @click="item.navtab"
                    >
                        <v-list-item-icon>
                            <v-icon>{{ item.icon }}</v-icon>
                        </v-list-item-icon>

                        <v-list-item-content>
                            <v-list-item-title v-text="item.title"></v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-group
                            :key="'g'+i"
                            :prepend-icon="item.icon"
                            append-icon="mdi-chevron-right"
                            v-if="item.navgroup !== undefined"
                            value="true"
                            no-action
                    >
                        <template v-slot:activator>
                            <v-list-item-title>{{ item.title }}</v-list-item-title>
                        </template>

                        <v-list-item
                                v-for="(subitem, i) in item.navgroup"
                                :key="i"
                                link
                                @click="subitem.navtab"
                        >
                            <v-list-item-content>
                                <v-list-item-title>
                                  {{ subitem.title }}
                                  <v-badge v-show="subitem.badge > 0" color="blue" offset-x="-10" offset-y="4"><span slot="badge">{{ subitem.badge }}</span> </v-badge>
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>

                    </v-list-group>
                </template>
            </v-list>
        </v-navigation-drawer>
        <v-app-bar
                app
                color="primary"
                dark
        >
            <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>

            <v-spacer></v-spacer>

            <v-btn @click="logoutClick" text>
                <span class="mr-2">Выход</span>
                <v-icon>mdi-open-in-new</v-icon>
            </v-btn>
        </v-app-bar>
    </div>
</template>

<script>
    import { bus } from '../plugins/bus.js'

    export default {
        name: "Menu",
        mounted() {
            if (this.$route.query.mail && this.$route.query.id && this.$route.query.flat) {
              this.$store.dispatch('AUTH_METRY_GET', {
                email: this.$route.query.mail,
                id: this.$route.query.id,
                flat: this.$route.query.flat
              })
                  .then(() => {

                  })
                  .catch(() => {
                    //this.errorMsg = e.toString();
                  });
            }

        },
        created: function () {
          this.$store.dispatch('GET_ZAYAVKILIST_NEW', {IdState: 0, IdSender: localStorage.getItem('idtsg')}).then(response => {
            this.menus[1].navgroup[0].badge = response.data;
          });
        },
        data () {
            return {
                drawer: true,
                menus: [
                    { title: 'Справочники', icon: 'mdi-format-columns', open: true,
                        navgroup: [
                            { title: 'Статьи оборота', icon: 'mdi-square-medium', navtab: () => {
                                bus.$emit('newTab', 'Cтатьи оборота', 0, 'StatiiZatrat', {});
                            }},
                        ]
                    },
                    { title: 'Бюджет', icon: 'mdi-cash-100', open: true,
                        navgroup: [
                            { title: 'Заявки', icon: 'mdi-square-medium', badge: 0, navtab: () => {
                                bus.$emit('newTab', 'Заявки', 0, 'Zaiavki', {})
                            }},
                            { title: 'БДДС (план)', icon: 'mdi-square-medium', navtab: () => {
                                bus.$emit('newTab', 'БДДС (план)', 0, 'BddsPlan', {})
                            }},
                            { title: 'БДДС (факт)', icon: 'mdi-square-medium', navtab: () => {
                                bus.$emit('newTab', 'БДДС (факт)', 0, 'BddsFact', {})
                            }},
                            { title: 'БДДС (план/факт)', icon: 'mdi-square-medium', navtab: () => {
                                bus.$emit('newTab', 'БДДС (план/факт)', 0, 'BddsPlanFact', {})
                            }},
                            { title: 'Планируемое поступление', icon: 'mdi-square-medium', navtab: () => {
                                    bus.$emit('newTab', 'Планируемое поступление', 0, 'PlanPostuplen', {})
                                }}
                        ]
                    },
                ],
            }
        },
        methods: {
          logoutClick() {
            this.$store.dispatch('AUTH_LOGOUT', {email: this.email, password: this.password});
          }
        },
    }
</script>

<style lang="sass">
    .v-list-group--active > .v-list-group__header
        > .v-list-group__header__append-icon .v-icon
            transform: rotate(90deg)
        &.v-list-group__header--sub-group
            > .v-list-group__header__prepend-icon .v-icon
                transform: rotate(90deg)
</style>